import React, { Component } from 'react';
import i18n from 'kodyl-js/i18n/react';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router';
import CityNav from '../cities/top-nav';

// TODO: Hide CityNav on frontpage

@i18n
class Footer extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <React.Fragment>
        <CityNav hideOthersLink className="above-footer" />
        <footer className="footer">
          <Grid>
            <Row>
              <Col sm={3} smPush={3}>
                <h4>{this.i18n('About Boligninja.dk')}</h4>
                <ul>
                  <li>
                    <Link to="/info/contact">{this.i18n('Contact us')}</Link>
                  </li>
                  <li>
                    <Link to="/info/about">
                      {this.i18n('About Boligninja.dk')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/info/faq">{this.i18n('FAQ')}</Link>
                  </li>
                  <li>
                    <Link to="/info/partners">{this.i18n('Partners')}</Link>
                  </li>
                  <li>
                    <Link to="/info/terms">{this.i18n('Terms of use')}</Link>
                  </li>
                  <li>
                    <Link to="/info/klagemulighed">
                      {this.i18n('Klagemulighed')}
                    </Link>
                  </li>
                  <li>
                    <a href="https://www.boligninja.dk/artikler">Artikler</a>
                  </li>
                </ul>
              </Col>
              <Col sm={3} smPull={3}>
                <hr className="visible-xs" />
                <Link
                  to="/"
                  style={{
                    display: 'block',
                    fontSize: '18px',
                    textDecoration: 'none',
                    color: '#fff'
                  }}
                >
                  <b>
                    Bolig
                    <span>ninja</span>
                  </b>{' '}
                  <small>ApS</small>
                  <span className="fa-stack">
                    <i
                      className="fa fa-circle fa-stack-2x"
                      style={{ color: '#000' }}
                    />
                    <i
                      className="fa fa-home fa-stack-1x fa-inverse"
                      style={{ top: '-1px' }}
                    />
                  </span>
                </Link>
                Niels Bohrs Vej 61
                <br />
                DK-8660 Skanderborg
                <br />
                info (a) boligninja.dk
                <br />
                CVR-nr. DK 37 14 89 97
              </Col>
              <div className="col-sm-3 hidden-xs">
                <h4>{this.i18n('Popular Cities')}</h4>
                <ul>
                  <li>
                    <Link to="/randers">Randers</Link>
                  </li>
                  <li>
                    <Link to="/kolding">Kolding</Link>
                  </li>
                  <li>
                    <Link to="/viborg">Viborg</Link>
                  </li>
                  <li>
                    <Link to="/horsens">Horsens</Link>
                  </li>
                  <li>
                    <Link to="/vejle">Vejle</Link>
                  </li>
                  <li>
                    <Link to="/byer">{this.i18n('Show all cities')}</Link>
                  </li>
                </ul>
              </div>
              <div className="col-sm-3 hidden-xs">
                <h4>&nbsp;</h4>
                <ul>
                  <li>
                    <Link to="/esbjerg">Esbjerg</Link>
                  </li>
                  <li>
                    <Link to="/naestved">Næstved</Link>
                  </li>
                  <li>
                    <Link to="/slagelse">Slagelse</Link>
                  </li>
                  <li>
                    <Link to="/haderslev">Haderslev</Link>
                  </li>
                  <li>
                    <Link to="/skive">Skive</Link>
                  </li>
                </ul>
              </div>
            </Row>
          </Grid>
          <div className="copyright">
            <Grid>
              <Row>
                <span className="payment-methods col-sm-3">
                  <i className="fa fa-lg fa-cc-visa" />{' '}
                  <i className="fa fa-lg fa-cc-mastercard" />
                </span>
                <div className="col-sm-6">
                  {this.i18n(
                    '%s Boligninja.dk - All rights reserved',
                    `© ${new Date().getFullYear()}`
                  )}
                </div>
                <span className="social-medias col-sm-3" />
              </Row>
            </Grid>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

export default Footer;
